import { useEffect } from 'react';
import { useScrollBlock } from 'providers/blockScroll';

const BlockScroll: React.FC = () => {
  const { blockScroll } = useScrollBlock();
  useEffect(() => {
    return blockScroll();
  }, [blockScroll]);
  return null;
};

export default BlockScroll;
